import React from "react";

import { ReducersTypes } from "../redux/reducers/Models";
import { Link } from 'react-router-dom';
import Icon from '@/atomic/atoms/Icon';
import Loading from '@/atomic/atoms/Loading';
import LoginModal from '@/atomic/atoms/LoginModal';
import Modal from '@/atomic/atoms/Modal';
import Footer from '@/atomic/atoms/Footer';
import LanguageSelector from '@/atomic/atoms/LanguageSelector';
import environment from '@/settings/environment';
import useI18n from '@/hooks/useI18n';

export interface PropsView {
  toggleMenu: () => void;
  isVisibleMenu: boolean;
  user: ReducersTypes['userReducer'];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  goToDebts: (e: React.ChangeEvent<HTMLFormElement>) => void;
  isDisabled: boolean;
  isLoading: boolean;
  error: boolean;
  isVisibleModal: boolean;
  toggleModal: () => void;
  isAcceptedTerms: boolean;
  toggleTerms: () => void;
  isVisibleModalLogin: boolean;
  toggleModalLogin: () => void;
  goToCreateAccount: () => void;
  isCaptchaVerified: boolean;
  isCaptchaMtcCaptcha: boolean;
}

export default function IndexView({
  toggleMenu,
  isVisibleMenu,
  user,
  onChange,
  goToDebts,
  isDisabled,
  isLoading,
  error,
  isVisibleModal,
  toggleModal,
  isAcceptedTerms,
  toggleTerms,
  isVisibleModalLogin,
  toggleModalLogin,
  goToCreateAccount,
  isCaptchaVerified,
  isCaptchaMtcCaptcha
}: PropsView) {

  const { t, Trans } = useI18n();

  const getMessage = () => {
    if (error) return t("pages:welcome:modalMessageDebtsNotFound");
    return t("pages:welcome:modalMessagePaymentAlreadyAutomated");
  }

  return (
    <div className="w-full h-full bg-[url('./assets/home-desk-2x.png')] bg-cover bg-fixed bg-center md:bg-center">
      <div className="absolute inset-0 backdrop-grayscale-0"></div>
      <main className="relative h-full w-full min-h-screen flex flex-col justify-between">
        <header className="w-full md:max-w-7xl md:mx-auto flex flex-col md:flex-row items-center p-3 ">
          <div className="flex items-center w-full md:w-1/2 justify-between md:justify-start m-4">
            <Icon className='dark' />
            <div className="flex items-center gap-2">
              <LanguageSelector
                className="text-black md:text-white md:hidden"
                showFlag={true}
              />
              <button
                onClick={toggleMenu}
                data-collapse-toggle="navbar-default"
                type="button"
                className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-white border rounded-lg md:hidden focus:outline-none focus:ring-2 dark:text-gray-400"
                aria-controls="navbar-default"
                aria-expanded="false"
              >
                <span className="sr-only">{isVisibleMenu ? "Close main menu" : "Open main menu"}</span>
                <img
                  src={isVisibleMenu ? "./icon-menu-close.png" : "./icon-menu.png"}
                  alt="ícone menu"
                  width={24}
                  height={24}
                />
              </button>
            </div>
          </div>
          <nav className="flex w-full md:w-1/2 justify-end md:mt-0">
            <ul
              id="navbar-default"
              className={`
                ${!isVisibleMenu ? "hidden" : ""}
                mt-2 md:mt-0
                rounded-lg bg-white p-2 text-black
                md:bg-transparent md:text-white md:flex md:p-0
                w-full md:w-auto
                flex-col md:flex-row
                items-center
                text-center
                md:justify-end
              `}
            >
              <li className="p-2">
              <LanguageSelector
                className="text-black hidden md:text-white md:block"
                showFlag={true}
              />
              </li>
              <li className="p-2">
                <button onClick={toggleModalLogin} className="text-black md:text-white">{t("navigation:login")}</button>
              </li>
              <li className="p-2">
                <Link to="/faq" className="text-black md:text-white">{t("navigation:faq")}</Link>
              </li>
              <li className="p-2">
                <button className='md:border md:border-1 md:rounded-lg md:p-2 md:px-4 text-black md:text-white' onClick={goToCreateAccount}>
                  {t("navigation:createAccount")}
                </button>
              </li>
            </ul>
          </nav>
        </header>

        <article className="mt-5 md:h-[calc(100%-145px)] flex-1 flex p-3 justify-center items-center md:justify-around flex-col md:flex-row md:max-w-7xl md:mx-auto w-full">
          <div className="hidden md:block flex w-full justify-center flex-col p-3 text-left md:text-left max-w-[calc(780px)]">
            <h1 className="text-2xl md:text-[4rem] font-bold leading-none uppercase text-white">
              <Trans
                i18nKey="pages:welcome:heroSectionTitle"
                components={[<span className="text-principal uppercase"></span>]}
              />
            </h1>
            <h2 className="text-sm md:text-lg text-white mt-4 max-w-[calc(380px)]">{t("pages:welcome:heroSectionSubtitle")}</h2>
          </div>
          <form className="w-full md:max-w-96 flex justify-start items-center flex-col bg-gray-200 rounded-xl p-6 min-h-96 md:max-h-calc(480px) mt-4 md:mt-0" onSubmit={isDisabled ? () => null : goToDebts}>
            <h3 className="w-full text-black text-xl mb-3">
              <Trans
                i18nKey="pages:welcome:labelTitle"
                components={[<span className="font-bold"></span>, <span className="font-bold"></span>, <span className="font-bold"></span>]}
              />
            </h3>
            <input
              value={user?.plate as string ?? ''}
              name="plate"
              placeholder={t('pages:welcome:placeholderPlate')}
              className="uppercase w-full h-14 rounded-xl p-3 text-black mt-2"
              onChange={onChange}
              type="text"
              minLength={5}
              maxLength={7}
            />
            <div className='flex flex-col items-start justify-start mt-4 w-full'>
              <label className="flex items-center cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={isAcceptedTerms}
                  onChange={toggleTerms}
                  className="w-6 h-6 accent-black mr-2 mt-1"
                />
                <div className='flex flex-1'>
                  <span className="text-sm text-black">
                    <Trans
                      i18nKey="pages:welcome:labelTermsAndPrivacy"
                      components={[
                        <Link to="/terms" className="underline italic text-gray-500" />,
                        <Link to="/policy" className="underline italic text-gray-500" />,
                      ]}
                    />
                  </span>
                </div>
              </label>
            </div>
            <div className="w-full p-4">
              {isCaptchaMtcCaptcha ? (
                <div className="mtcaptcha" id="mtcaptcha-intern" data-callback="onCaptchaSuccess"></div>
              ) : (
                <div
                  className="g-recaptcha mx-auto"
                  data-sitekey={environment.recaptcha.siteKey}
                  data-size="normal"
                  data-theme="light"
                  data-callback="onRecaptchaVerify"
                  data-expired-callback="onRecaptchaExpired"
                  data-error-callback="onRecaptchaError"
                />
              )}
            </div>
            <button
              type="submit"
              className={`w-full mt-6 h-14 text-white border p-3 rounded-xl ${isDisabled ? "bg-gray-300 text-white" : "bg-black border-black"}`}
              disabled={isDisabled}>
              {t("pages:welcome:searchDebts")}
            </button>
            <button type="button" className='mt-6 text-large text-black underline' onClick={toggleModalLogin}>
              {t("pages:welcome:startNow")}
            </button>
          </form>
        </article>
      </main>
      {isVisibleModalLogin && <LoginModal toggleModalLogin={toggleModalLogin} />}
      {isVisibleModal && <Modal
        title={t("pages:welcome:modalTitleAttention")}
        message={getMessage()}
        actionMessage={t("common:close")}
        action={toggleModal}
        actionSecond={toggleModal}
      />}
      {isLoading && <Loading />}
      <Footer />
    </div>
  );
}
